import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-235bdc1e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "message-merger" }
const _hoisted_2 = ["data-value"]
const _hoisted_3 = { class: "merger-title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "merger-label" }, " 聊天记录", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "merger-box",
      "data-value": _ctx.data.message
    }, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.data.title), 1),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.abstractList, (item, index) => {
        return (_openBlock(), _createElementBlock("p", {
          class: "merger-text",
          key: index
        }, _toDisplayString(item), 1))
      }), 128))
    ], 8, _hoisted_2),
    _hoisted_4
  ]))
}